module.exports = __webpack_public_path__ + "static/media/tab02img07.f27ba6d9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/04/02/assets/tab02img07.mp4
// module id = 534
// module chunks = 0